"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Header_1 = require("./Header");
var Section1_1 = require("./Section1");
var Section2_1 = require("./Section2");
var styles = __importStar(require("./Nursing.module.css"));
var Nursing = (function (_super) {
    __extends(Nursing, _super);
    function Nursing(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = function (id, value, costData) {
            if (costData === void 0) { costData = null; }
            _this.json_data[id] = value;
            if (_this.json_data.termBeginning && costData) {
                var cost_1 = costData.costs;
                Object.keys(cost_1).forEach(function (item) {
                    _this.json_data[item] = cost_1[item].toString();
                });
                _this.calcCost();
            }
            _this.forceUpdate();
            _this.props.reload();
        };
        _this.calcCost = function () {
            var tuitionValue = Number.parseFloat(String(_this.json_data["financial__tuition"] || "")) || 0;
            var feeValue = Number.parseFloat(String(_this.json_data["financial__textbooks"] || "")) || 0;
            var textbooksValue = Number.parseFloat(String(_this.json_data["financial__fees"] || "")) || 0;
            _this.json_data["financial__totalCost"] = tuitionValue + feeValue + textbooksValue;
        };
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Nursing.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.errors = this.props.model.errors;
        this.forceUpdate();
    };
    Nursing.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.reload();
                return [2];
            });
        });
    };
    Nursing.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    Nursing.prototype.render = function () {
        var model = this.props.model;
        var _a = this, errors = _a.errors, json_data = _a.json_data;
        var data = __assign({}, json_data);
        return (React.createElement("div", { className: "intellitec-form" },
            React.createElement("div", { className: "gray-line" }),
            React.createElement(Header_1.Header, null,
                React.createElement("p", { className: styles.headerTitle }, "ENROLLMENT AGREEMENT"),
                React.createElement("p", { className: styles.headerAddress }, "IntelliTec College 3673 Parker Blvd. Pueblo, CO 81008 (719)542-3181"),
                React.createElement("p", { className: styles.headerBranch }, "Satellite Location \u2013 Automotive Technician Program\u2013 713 E. Spaulding Ave. Pueblo, CO 81007"),
                React.createElement("p", { className: styles.headerBranch }, "(Branch Campus of IntelliTec College, Grand Junction)"),
                React.createElement("p", { className: styles.headerDescription }, "APPROVED AND REGULATED BY THE COLORADO DEPARTMENT OF HIGHER EDUCATION, PRIVATE OCCUPATIONAL SCHOOL BOARD")),
            React.createElement(Section1_1.Section1, { model: model, errors: errors, onChange: this.onChange, json_data: data }),
            React.createElement("div", { className: styles.gapSection1 }),
            React.createElement("div", { className: "gray-line" }),
            React.createElement(Header_1.Header, null,
                React.createElement("p", { className: styles.headerTitle }, "ENROLLMENT AGREEMENT (CONTINUED)")),
            React.createElement(Section2_1.Section2, { model: model, errors: errors, onChange: this.onChange, json_data: data })));
    };
    __decorate([
        mobx_1.observable
    ], Nursing.prototype, "errors", void 0);
    Nursing = __decorate([
        mobx_react_1.observer
    ], Nursing);
    return Nursing;
}(react_1.Component));
exports.Nursing = Nursing;
//# sourceMappingURL=data:application/json;base64,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